//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('statisticsReferralProgram', ['page', 'pages', 'data', 'sort']),
  },

  methods: {
    ...mapActions('statisticsReferralProgram', {
      loadDataAction: 'loadData',
    }),

    getThirtyPercentAmounts(arr) {
      if (Array.isArray(arr) && arr.length > 0) {
        // Получаем массив значений amount из объектов в incomeStats
        const amountsArray = arr.map((stat) => stat.amount);

        // Вычисляем количество элементов, которое составляет 30% от длины массива
        const thirtyPercentCount = Math.ceil(amountsArray.length * 0.3);

        // Если количество элементов меньше двух, возвращаем весь массив значений amount
        if (thirtyPercentCount < 2) {
          return amountsArray;
        }

        // Вычисляем шаг для выбора элементов с примерно равным расстоянием между ними
        const step = Math.floor(amountsArray.length / thirtyPercentCount);

        // Создаем новый массив для хранения 30% элементов и выбираем элементы из исходного массива с определенным шагом
        return Array.from({ length: thirtyPercentCount }, (_, i) => amountsArray[i * step]);
      }
      return [];
    },
  },
};
